
import { defineComponent } from "vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import ECP_EDP_DashboardNavigator from "@/components/cards/ECP_EDP_DashboardNavigator.vue";
import GlobalPartnersMapCard from "@/components/dashboard/sequence/GlobalPartnersMapCard.vue";
import { getDashboardData } from "@/api/dashboard";

export default defineComponent({
  name: "GlobalPartners",
  components: {
    ECP_EDP_DashboardNavigator,
    GlobalPartnersMapCard,
  },
  data() {
    return {
      pt: "",
      ccode: -1,
    };
  },
  mounted() {
    setCurrentPageTitle("Global Partners");
    this.pt = String(localStorage.getItem("pt"));
    this.loadCountryCode();
  },
  methods: {
    async loadCountryCode() {
      try {
        const response = await getDashboardData();
        if (response?.data?.countryCode != null) {
          this.ccode = response.data.countryCode;
        }
      } catch (error) {
        console.error("Failed to load country code for global partners map:", error);
      }
    },
  },
});
